module.exports = __webpack_public_path__ + "img/album05_22.51c82de3.jpg";